import { Routes, RouterModule } from '@angular/router';

/*import { DashboardComponent } from './dashboard.component';
import { HeroesComponent } from './heroes.component';
import { HeroDetailComponent } from './hero-detail.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';*/
import { LoginComponent } from './login/login.component';
import { AppComponent } from './app.component';
import { LoginGameComponent } from './login-game/login-game.component';
import { QuizComponent } from './quiz/quiz.component';
import { Break1Component } from './break1/break1.component';
import { Break2Component } from './break2/break2.component';
import { Break3Component } from './break3/break3.component';
import { Break4Component } from './break4/break4.component';
import { Break5Component } from './break5/break5.component';
import { Break6Component } from './break6/break6.component';
import { Break7Component } from './break7/break7.component';
import { Break8Component } from './break8/break8.component';
import { Break9Component } from './break9/break9.component';
import { Break10Component } from './break10/break10.component';
import { Break11Component } from './break11/break11.component';
import { Break12Component } from './break12/break12.component';
import { Break13Component } from './break13/break13.component';
import { Break14Component } from './break14/break14.component';
import { Break15Component } from './break15/break15.component';
import { Break16Component } from './break16/break16.component';
import { Break17Component } from './break17/break17.component';
import { Break18Component } from './break18/break18.component';
import { Break19Component } from './break19/break19.component';
import { Break20Component } from './break20/break20.component';
import { Break21Component } from './break21/break21.component';
import { Break22Component } from './break22/break22.component';
import { Break23Component } from './break23/break23.component';
import { Break24Component } from './break24/break24.component';
import { Break25Component } from './break25/break25.component';
import { Break26Component } from './break26/break26.component';
import { MerciComponent } from './merci/merci.component';
import { TopicComponent } from './topic/topic.component';
import { ValidateEmailComponent } from './validate-email/validate-email.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ProfileDiscoveryComponent } from './profile-discovery/profile-discovery.component';
import { InviteComponent } from './invite/invite.component';
/*import { QuizComponent } from './quiz/quiz.component';
import {ValidateEmailComponent} from "./validate-email/validate-email.component";
import {ProfileDiscoveryComponent} from "./profile-discovery/profile-discovery.component";*/

const appRoutes: Routes = [
    /*{ path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home', component: AppComponent },
    { path: 'home/campaign/:url', component: LoginComponent },
    { path: 'campaign/:url/login', component: LoginGameComponent },
    {path: 'campaign/:url/questionnaire/:index/:orientation', component: QuizComponent},
    {path: 'campaign/:url/break/break1/:orientation/:next', component: Break1Component},
    {path: 'campaign/:url/break/break2/:orientation/:next', component: Break2Component},
    {path: 'campaign/:url/break/break3/:orientation/:next', component: Break3Component},
    {path: 'campaign/:url/break/break4/:orientation/:next', component: Break4Component},
    {path: 'validate-email/:url/:hash', component: ValidateEmailComponent},
    {path: 'campaign/:url/discover-profile', component: ProfileDiscoveryComponent},
    {path: 'page-not-foud', component: PageNotFoundComponent},
    { path: '**', redirectTo: 'page-not-foud' }*/
  { path: '', redirectTo: 'page-not-foud', pathMatch: 'full' },
  { path: ':url', component: LoginComponent },
  { path: ':url/login/:hash', component: LoginGameComponent },
  { path: ':url/login', component: LoginGameComponent },
  {path: ':url/questionnaire/:index/:orientation', component: QuizComponent},
  {path: ':url/break/break1/:orientation/:next', component: Break1Component},
  {path: ':url/break/break2/:orientation/:next', component: Break2Component},
  {path: ':url/break/break3/:orientation/:next', component: Break3Component},
  {path: ':url/break/break4/:orientation/:next', component: Break4Component},
  {path: ':url/break/break5/:orientation/:next', component: Break5Component},
  {path: ':url/break/break6/:orientation/:next', component: Break6Component},
  {path: ':url/break/break7/:orientation/:next', component: Break7Component},
  {path: ':url/break/break8/:orientation/:next', component: Break8Component},
  {path: ':url/break/break9/:orientation/:next', component: Break9Component},
  {path: ':url/break/break10/:orientation/:next', component: Break10Component},
  {path: ':url/break/break11/:orientation/:next', component: Break11Component},
  {path: ':url/break/break12/:orientation/:next', component: Break12Component},
  {path: ':url/break/break13/:orientation/:next', component: Break13Component},
  {path: ':url/break/break14/:orientation/:next', component: Break14Component},
  {path: ':url/break/break15/:orientation/:next', component: Break15Component},
  {path: ':url/break/break16/:orientation/:next', component: Break16Component},
  {path: ':url/break/break17/:orientation/:next', component: Break17Component},
  {path: ':url/break/break18/:orientation/:next', component: Break18Component},
  {path: ':url/break/break19/:orientation/:next', component: Break19Component},
  {path: ':url/break/break20/:orientation/:next', component: Break20Component},
  {path: ':url/break/break21/:orientation/:next', component: Break21Component},
  {path: ':url/break/break22/:orientation/:next', component: Break22Component},
  {path: ':url/break/break23/:orientation/:next', component: Break23Component},
  {path: ':url/break/break24/:orientation/:next', component: Break24Component},
  {path: ':url/break/break25/:orientation/:next', component: Break25Component},
  {path: ':url/break/break26/:orientation/:next', component: Break26Component},
  {path: ':url/merci', component: MerciComponent},
  {path: 'validate-email/:url/:hash', component: ValidateEmailComponent},
  {path: ':url/discover-profile', component: ProfileDiscoveryComponent},
  {path: ':url/topic', component: TopicComponent},
  {path: ':url/invite', component: InviteComponent},
  {path: 'page-not-foud', component: PageNotFoundComponent},
  { path: '**', redirectTo: 'page-not-foud' }

  /*{
    path: '',
    redirectTo: 'page-not-found',
    pathMatch: 'full'
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent
  },
  {
    path: 'validate-email/:url/:hash',
    component: ValidateEmailComponent
  },
  {
    path: 'campaign/:url',
    component: LoginComponent
  }*/
  /*{
    path: 'campaign/:url/login',
    component: LoginGameComponent
  },
  {
    path: 'campaign/:url/questionnaire/:index/:orientation',
    component: QuizComponent
  },
  {
    path: 'campaign/:url/break/break1/:orientation/:next',
    component: Break1Component
  },
  {
    path: 'campaign/:url/break/break2/:orientation/:next',
    component: Break2Component
  },
  {
    path: 'campaign/:url/break/break3/:orientation/:next',
    component: Break3Component
  },
  {
    path: 'campaign/:url/break/break4/:orientation/:next',
    component: Break4Component
  },
  {
    path: 'campaign/:url/discover-profile',
    component: ProfileDiscoveryComponent
  }*/
];

export const routing = (appRoutes);

//export const routedComponents = [DashboardComponent, HeroesComponent, HeroDetailComponent];



// WEBPACK FOOTER //
// /Users/mosheborochov/Desktop/work/QCEV/dev/QCEV-FRONT/src/app/app.routing.ts